import React from "react";
import { UserRoleMaintenancePageInitialState, PageNewState } from ".";

export const UserRoleMaintenancePageContext = React.createContext({
  pageState: UserRoleMaintenancePageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
